<template>
  <div>
    <p class="text-text-neutral-tertiary mb-3 text-xs font-medium">
      {{ t('roamingDevices.choose-brand') }}
    </p>
    <button
      type="button"
      class="bg-situational-lightgrey flex w-full items-center justify-between rounded-2xl py-4 pr-3 pl-4"
      @click="emit('onClick')"
    >
      <span class="text-text-neutral-primary">{{ selectedBrand }}</span>
      <img
        src="./assets/chevron-down-black-icon.svg"
        class="h-6 w-6"
        width="24"
        height="24"
        alt=""
        role="presentation"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import messages from '../locales.json';

  const { t } = useI18n({ messages });

  defineProps<{
    selectedBrand: string;
  }>();

  const emit = defineEmits<{
    onClick: [];
  }>();
</script>
